import axios from 'axios'
import { onUnauthorized } from '../api/session'
import { getAuthToken } from './TokenUtility'

/* Client unique de location-service (Z2-38). En développement, l'URL reste
   relative : setupProxy.js route /location, /quest, /trou… vers le service.
   src/services/locationApi.ts n'est plus qu'un alias de celui-ci. */
const locationApi = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? 'https://dev-location.tribe.sn'
    : '',
})
locationApi.interceptors.request.use((config: any) => {
  const token = getAuthToken()
  if (token) {
    config = {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      },
    }
  }
  return config
})

/* Les instances créées par axios.create() n'héritent pas des intercepteurs
   posés sur l'instance axios par défaut : le 401 doit être traité ici aussi. */
locationApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      onUnauthorized()
    }
    return Promise.reject(error)
  }
)

export default locationApi
